import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsExpenses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      expenses_data: props.expenses_data || null,
      has_split_jobs: props.has_split_jobs || null,
      expenses_approval_data: props.expense_approval_data || null,
      isLoadingExpensesInfo: true,
      downloadExpensesImagesForJobUrl: '/api/v1/portal/jobs/download-expenses-images',
      showAddExpenseForm: false,
      isMarkJobAsCheckedLoading:false,
      setJobAsReadyToBeInvoiceLoading:false,
      setJobReadyToBeInvoice:true,
      preApprovalExp:[{
        pre_approved_expense_type:4001,
        pre_approved_expense_percentage:0
      }],
      customerAllJobsPage:props.customerAllJobsPage || false,
      job_as_ready_to_be_invoiced : 0,
      isSavingExpenseSettings: false,
      isAddingExpense: false,
      // pre_approved_expense_type:props.data.pre_approved_expense_type|| 4001,
      // pre_approved_expense_percentage:props.data.pre_approved_expense_percentage|| 0,
      //setSaveBtnDisable:(props.data.pre_approved_expense_type && props.data.pre_approved_expense_percentage) ? true : false
    };

    this.saveExpenseSettings = this.
    saveExpenseSettings.bind(this); 
    this.handleAddExpenseFileConvert = this.
    handleAddExpenseFileConvert.bind(this);
    this.handleChangeChk = this.handleChangeChk.bind(this);

    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).
    listen(
      'ExpensesInfoChanged',
      (e) => {
        this.getExpensesInfo();
      }
    );
  }

  componentDidMount() {
    this.getExpensesInfo();
    let pre_approved_expense_items = (this.state.data.pre_approved_expense_items != null) ? JSON.parse(this.state.data.pre_approved_expense_items) : null;
    if(pre_approved_expense_items != null){
      this.setState({preApprovalExp:pre_approved_expense_items});
    }
  }

  getExpensesInfo() {
    let url = '/api/v1/portal/expenses-info/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((expensesInfoJson) => {
        this.setState({
          expenses_data: expensesInfoJson['expenses_data'],
          expense_approval_data: expensesInfoJson['expense_approval_data'],
          isLoadingExpensesInfo: false,
          has_split_jobs: expensesInfoJson['has_split_jobs'],
        })
      });
    });
  }

  toggleMarkJobAsChecked(e,value) {
    this.setState({isMarkJobAsCheckedLoading:true});  
    $.ajax({
      url: "/api/v1/portal/jobs/mark-as/toggle/checked/"+
        this.state.data.id,
      data: {
        api_token: window.api_token
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
      this.setState({isMarkJobAsCheckedLoading:false});  
      this.setState({
        data: {
        ...this.state.data,
        checked: value
        }
      });
    }.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      customerAllJobsPage:nextProps.customerAllJobsPage
    });
  }
  handleChangeChk(event){
    let checklistVal = $('#invoice_checklist_have_the_pods_been_sent_off:checked').val();
    if(checklistVal == 'true'){
      this.setState({setJobReadyToBeInvoice:false});
    }else{
      this.setState({setJobReadyToBeInvoice:true});
    }
  }
  handleChangeOkToGoUnderCustomer(e,expId){
    let checkExpOk = $('#'+e.target.id+':checked').val();
    
    $.ajax({
      url: "/api/v1/portal/jobs/set-expense-to-go-under-customer-section/"+this.state.data.id,
      data: {
        api_token: window.api_token,
        expense_name:expId,
        is_checked_togo_under_customer:(checkExpOk == "true") ? 1:0
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        alert(data);
    }.bind(this));
  }
  downloadExpensesImagesForJob(e, jobId) {
    var buttonText = '<i className="fa fa-download"></i> Download Expenses Images as .zip';
    $('.downloadExpenseImage').addClass('buttonDisabled');
    $('.downloadExpenseImage').text('Downloading ...');
    return fetch(this.state.downloadExpensesImagesForJobUrl+'/'+jobId,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/zip'
        },
      }).then((responseText) => {
      $('.downloadExpenseImage').removeClass('buttonDisabled');
      $('.downloadExpenseImage').html(buttonText);
      let response = responseText.blob();
      response.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          jobId+'-expenses-images.zip'
        );
        document.body.appendChild(link);
        link.click();
      });
    });
  }

  setJobAsReadyToBeInvoiced() {
    let checklistVal = $('#invoice_checklist_have_the_pods_been_sent_off:checked').val();
    let postData = false;
    if(checklistVal){
      postData = true;
    }
    $.ajax({
      url: "/api/v1/portal/jobs/set-as-ready-to-be-invoiced/"+
        this.state.data.id,
      data: {api_token: window.api_token,isCustomerAgreedForCheckList:postData},
      cache: false,
      method: 'post',

    })
    .done(function(data) {
      this.setState({
        data: {
        ...this.state.data,
        ready_for_invoice: 1
        }
      });
      this.setState({setJobAsReadyToBeInvoiceLoading:false});
    }.bind(this));
  }
  handleApproveJobToGoOnWagesSheet(){
    this.setState({setJobAsReadyToBeInvoiceLoading:true});
    $.ajax({
      url: "/api/v1/portal/jobs/set-job-as-ready-togo-onwages/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
        this.setState({
          data: {
            ...this.state.data,
            ready_for_wages: 1
          }
        });
    }.bind(this));
  }
  handleNotApproveJobToGoOnWagesSheet(){
    this.setState({setJobAsReadyToBeInvoiceLoading:true});
    $.ajax({
      url: "/api/v1/portal/jobs/set-job-as-not-ready-togo-onwages/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
        this.setState({
          data: {
            ...this.state.data,
            ready_for_wages: 0
          }
        });
    }.bind(this));
  }
  setJobAsNotReadyToBeInvoiced() {
    this.setState({setJobAsReadyToBeInvoiceLoading:true});
    $.ajax({
      url: "/api/v1/portal/jobs/set-as-not-ready-to-be-invoiced/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
        this.setState({
          data: {
          ...this.state.data,
          ready_for_invoice: 0
          }
        });
    }.bind(this));
  }

  saveExpenseSettings(expenseName) {
    // Set isSavingExpenseSettings to true before making the AJAX call
    // mark only this expense as saving
    this.setState((prevState) => ({
      isSavingExpenseSettings: {
      ...prevState.isSavingExpenseSettings,
      [expenseName]: true,
      },
    })); 
    let jobId = this.state.data.id,
      expenseContainer = "[data-expense-name='"+expenseName+"']",
      epxIndex = $(expenseContainer).attr('data-expense-index'),
      expenseUploadcare = $(
        expenseContainer + " [name=uploadcare_image_url]"
      ).val(), 
      expenseDescription = $(
        expenseContainer + " [name=description]"
      ).val(),
      expenseCostInPence = $(
        expenseContainer + " [name=expense_cost_in_pence]"
      ).val() * 100,
      expenseApproved = $(
        expenseContainer + " label.active [name=expense_approved]"
      ).val(),
      is_checked_togo_under_customer = $("#ok_to_go_under_customer_login_"+epxIndex+':checked').val(),
      expenseReason = $(
        expenseContainer + " [name=expense_reason]"
      ).val(),
//      expenseCustomerVatCode = $(
//        expenseContainer + " [name=expense_customer_vat_code]"
//      ).val(),
      expenseType = $(
        expenseContainer + " [name=expense_type]"
      ).val(),
      expenseVatCode = $(
        expenseContainer + " [name=expense_vat_code]"
      ).val(),
      expenseClientChargeInPence = $(
        expenseContainer + " [name=expense_client_charge]"
      ).val() * 100,
      expenseDriverPayInPence = $(
        expenseContainer + " [name=expense_driver_pay]"
      ).val() * 100;
    
    let successmsg = 'This expense has been ';
    let modalFooter = ""; 
   
    successmsg += (expenseApproved == 1) ? 'approved.' : 'not approved.';
    $(expenseContainer).find('.save-settings-for-expense').prop("disabled", false);
    if(expenseApproved == 1 && expenseClientChargeInPence <= 0){
      $('#infomodallabel').html('Confirm Client Charge.');
      $('#infomodal .modal-body').html('Please confirm client charge should be 0.00');
      modalFooter += '<button type="button" class="btn btn-primary" id="modal-btn-si">Yes</button><button type="button" class="btn btn-danger" id="modal-btn-no">No</button>';
      $('#infomodal .modal-footer').html(modalFooter);
      $('#infomodal').modal();
    }else{
      $.ajax({
        url: "/api/v1/portal/expense-approval/" + jobId,
        data: {
          api_token: window.api_token,
          expense_name: expenseName,
          expense_uploadcare_image_url: expenseUploadcare,
          expense_description: expenseDescription,
          expense_cost_in_pence: expenseCostInPence,
          expense_approved: expenseApproved,
          is_checked_togo_under_customer:(is_checked_togo_under_customer == 'true') ? 1 : 0,
          expense_reason: expenseReason,
          expense_type: expenseType,
          expense_vat_code: expenseVatCode, 
          //expense_customer_vat_code: expenseCustomerVatCode,
          expense_client_charge_in_pence: expenseClientChargeInPence,
          expense_driver_pay_in_pence: expenseDriverPayInPence,
        },
        cache: false,
        method: 'post',
        dataType: "text/json",
        complete: function (response) {
          // Set isSavingExpenseSettings to false when the AJAX call is complete
          $(expenseContainer).find('.save-settings-for-expense').prop("disabled", false);
          if (response.status === 200) {
            $('#infomodallabel').html('Expense Settings Saved.');
            $('#infomodal .modal-body').html('Expense info updated.');
            $('#infomodal').modal();
            setTimeout(function () {
                $('#infomodal').modal('hide');
            }, 2000);
            // mark only this expense as saving
            this.setState((prevState) => ({
              isSavingExpenseSettings: {
              ...prevState.isSavingExpenseSettings,
              [expenseName]: false,
              },
            })); 
            $(expenseContainer).find('.expense-approval-msg').html(successmsg);
            if(expenseApproved == 1 || expenseApproved == 0){
                $(expenseContainer).find('.expense-form-radio-container').addClass('disabled');
            }
          } else {
            $('#infomodallabel').html('Error');
            $('#infomodal .modal-body').html(
            response.responseText.replace(/\"/g,
              "")
            );
            $('#infomodal').modal();
            setTimeout(function () {
                $('#infomodal').modal('hide');
            }, 2000);
            // mark only this expense as saving
            this.setState((prevState) => ({
              isSavingExpenseSettings: {
              ...prevState.isSavingExpenseSettings,
              [expenseName]: true,
              },
            })); 
          }
        }.bind(this)
      });
    }
    var modalConfirm = function(callback){
      $("#modal-btn-si").on("click", function(){
        callback(true);
        $("#infomodal").modal('hide');
      });
      $("#modal-btn-no").on("click", function(){
        callback(false);
        $("#infomodal").modal('hide');
      });
    };
    modalConfirm((confirm) => {
      if(confirm){
        $.ajax({
          url: "/api/v1/portal/expense-approval/" + jobId,
          data: {
            api_token: window.api_token,
            expense_name: expenseName,
            expense_uploadcare_image_url: expenseUploadcare,
            expense_description: expenseDescription,
            expense_cost_in_pence: expenseCostInPence,
            expense_approved: expenseApproved,
            is_checked_togo_under_customer:(is_checked_togo_under_customer == 'true') ? 1 : 0,
            expense_reason: expenseReason,
            expense_type: expenseType,
            expense_vat_code: expenseVatCode,
            //expense_customer_vat_code: expenseCustomerVatCode,
            expense_client_charge_in_pence: expenseClientChargeInPence,
            expense_driver_pay_in_pence: expenseDriverPayInPence,
          },
          cache: false,
          method: 'post',
          dataType: "text/json",
          complete: function (response) {
            setTimeout(()=>{
              $(expenseContainer).find('.save-settings-for-expense').prop("disabled", false);
              $('#infomodal .modal-footer').html('<button type="button" class="btn btn-primary" data-dismiss="modal">Okay</button>');
              if (response.status === 200) {               
                  $('#infomodallabel').html('Expense Settings Saved.');
                  $('#infomodal .modal-body').html('Expense info updated.');
                  $('#infomodal').modal();
                  setTimeout(function () {
                      $('#infomodal').modal('hide');
                  }, 2000);
                  $(expenseContainer).find('.expense-approval-msg').html(successmsg); 
                  if(expenseApproved == 1 || expenseApproved == 0){
                      $(expenseContainer).find('.expense-form-radio-container').addClass('disabled');
                  }
                  // mark only this expense as saving
                  this.setState((prevState) => ({
                    isSavingExpenseSettings: {
                    ...prevState.isSavingExpenseSettings,
                    [expenseName]: false,
                    },
                  }));          
              } else {
                $('#infomodallabel').html('Error');
                $('#infomodal .modal-body').html(
                response.responseText.replace(/\"/g,
                  "")
                );
                $('#infomodal').modal();
                setTimeout(function () {
                  $('#infomodal').modal('hide');
                }, 2000);
                // mark only this expense as saving
                  this.setState((prevState) => ({
                    isSavingExpenseSettings: {
                    ...prevState.isSavingExpenseSettings,
                    [expenseName]: false,
                    },
                  }));  
              }
            },200);
          }.bind(this)         
        });
      }else{
        $('#infomodal .modal-footer').html('<button type="button" class="btn btn-primary" data-dismiss="modal">Okay</button>');
        $(expenseContainer).find('.save-settings-for-expense').prop("disabled", false);
        $(expenseContainer + " [name=expense_client_charge]").focus();
      }
    }); 
    return false;
  }

  handleAddExpenseFileConvert() {
    let jobId = this.state.data.id;
    let uploadInput = document.getElementById(
      'add-expense-expense-image-input-'+jobId
    );

    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener("load", function(e) {
        document.getElementById(
          "add-expense-expense-image-"+jobId
        ).src = e.target.result;
        document.getElementById(
          "add-expense-expense-image-b64-"+jobId
        ).value = e.target.result;
      });

      fileReader.readAsDataURL(uploadInput.files[0]);
    }
    else {
      alert('sorry, error working with image');
    }
  }
  handlePreApprovedExpenseType(e,index){
    this.state.preApprovalExp[index].pre_approved_expense_type = e.target.value;
    this.setState({preApprovalExp:this.state.preApprovalExp});
  }
  handlePreApprovedPercentage(e,index){
    this.state.preApprovalExp[index].pre_approved_expense_percentage = e.target.value;
    this.setState({preApprovalExp:this.state.preApprovalExp});
  }
  handlePreApprovedExpenseReason(e,index){
    this.state.preApprovalExp[index].pre_approved_expense_reason = e.target.value;
    this.setState({preApprovalExp:this.state.preApprovalExp});
  }
  handleAddMoreBtnClick(e){
    this.setState({preApprovalExp:[...this.state.preApprovalExp,{
      pre_approved_expense_type:4001,
      pre_approved_expense_percentage:0
    }] });
  }
  handleRemoveSelectedPItem(e,index){
    this.state.preApprovalExp.splice(index,1);
    this.setState({preApprovalExp:this.state.preApprovalExp});
  }
  savePreApprovedExpenseOptions(e){
    let jobId = this.state.data.id;
    let newExpenseData ={
      api_token: window.api_token,
      pre_approved_expense_items:this.state.preApprovalExp
    }
    $.ajax({
      type: "POST",
      url: '/api/v1/portal/jobs/save-pre-approved-expense-options/'+jobId,
      data: newExpenseData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          document.getElementById('infomodallabel').innerHTML = 'Expense Pre Approval'
          document.querySelector('#infomodal .modal-body').
            innerHTML = 'Expense Pre Approval options saved successfully.';
          $('#infomodal').modal();
        }
        else {
          document.querySelector('#infomodallabel').
            innerHTML = 'Expense Pre Approve';
          $('#infomodal .modal-body').html('Error while saving expense pre approval options.');
          $('#infomodal').modal();
        }
      }
    });
  }
  addNewExpenseToJob(e) {
    e.preventDefault();
    this.setState({ isAddingExpense: true });
    let jobId = this.state.data.id;
    let newExpenseData= {
      api_token: window.api_token,

      expense_image: document.getElementById(
        "add-expense-expense-image-b64-"+jobId
      ).value,
      expense_type: document.getElementById(
        "add-expense-expense-type-"+jobId
      ).value,
      expense_cost: document.getElementById(
        "add-expense-expense-cost-"+jobId
      ).value,
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/jobs/add-new-expense/'+jobId,
      data: newExpenseData,
      dataType: "text/json",
      complete: function(response) {
        this.setState({ isAddingExpense: false });
        if (response.status === 200) {
          document.getElementById('infomodallabel').
            innerHTML = 'New Expense Uploaded to Job'
          document.querySelector('#infomodal .modal-body').
            innerHTML = 'Expense added successfully.';
          $('#infomodal').modal();
        }
        else {
          document.querySelector('#infomodallabel').
            innerHTML = 'Error adding new expense to job';

          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.
              replace(/\"/g, "")
            ));
          $('#infomodal').modal();
        }
      }.bind(this)
    });
  }

  renderExpensesInfoBlock() {
    let expensesInfoBlock;
    let Expenses = [];

    expensesInfoBlock = (
      <p className={(this.state.customerAllJobsPage) ? "toggle-hide":""}><strong>No expenses have been uploaded from driver app.</strong></p>
    );

    if (!this.state.isLoadingExpensesInfo &&
         this.state.expenses_data &&
        (this.state.expenses_data.length > 0)) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }

      let expenseNum = 0;
      let self = this;
      let expense = '';
      let expenseApprovalSettings = {};
      let expenseApprovalSetting = {};
      let expenseApproved = '';
      let expenseNotApproved = '';
      let expenseDefaultValue = '';
      let expenseReason = '';
      let expenseType = '';
      let expenseVatCode = '';
      let expenseCustomerVatCode = '';
      let expensemsg = '';
      let expenseApproval='';
      let has_split_jobs = this.state.has_split_jobs;
      let json = '';
      let expense_jobID = '';
      let isCheckedOkForCustomer = 0;
      this.state.expenses_data.forEach((i,index) =>{
        expense_jobID = (i.job_id != null) ? i.job_id+'-'+index : jobId+'-'+index;
        if(has_split_jobs === 1){
            json = JSON.parse(i.expenses_json.replace(/\\/g,''));
            
            json.forEach((i,index) =>{
              
                expense = (i.photo_name);
                expenseApprovalSettings = self.state.expense_approval_data;
                if (expense in expenseApprovalSettings) {
                  expenseApprovalSetting = expenseApprovalSettings[expense];
                  isCheckedOkForCustomer = expenseApprovalSetting.is_checked_togo_under_customer;
                  expenseApproved = '';
                  expenseNotApproved = '';
                  if (expenseApprovalSetting.approved === 1) {
                    expenseApproved = 'active';
                    expensemsg = 'This expense has been approved.';
                    expenseNotApproved = '';
                    expenseApproval = 'disabled';
                    expenseReason = expenseApprovalSetting.reason_for_approving;
                  }
                  else {
                    expenseApproved = '';
                    expenseNotApproved = 'active';
                    expensemsg = 'This expense has been not approved.';
                    expenseApproval = 'disabled';
                    expenseReason = expenseApprovalSetting.reason_for_not_approving;
                  }

                  expenseDefaultValue = (
                    expenseApprovalSetting.cost_in_pence/100
                  ).toFixed(2);
                  expenseType = expenseApprovalSetting.type;
                  expenseVatCode = expenseApprovalSetting.vat_code;
                  expenseCustomerVatCode = expenseApprovalSetting.customer_vat_code;
                }
                else {
                  expenseDefaultValue = (i.cost_in_pence/100).toFixed(2);
                  expenseApproved = '';
                  expenseNotApproved = '';
                  expenseReason = '';
                  expenseType = '';
                  expenseApproval = '';
                  expenseVatCode = '';
                  expenseCustomerVatCode = '';
                  expensemsg = '';
                  expenseApprovalSetting.driver_pay_in_pence = 0;
                  expenseApprovalSetting.client_charge_in_pence = 0;
                }
                expenseNum++;

                if (!expenseApprovalSetting.client_charge_in_pence) {
                  expenseApprovalSetting.client_charge_in_pence = 0;
                }

                if (!expenseApprovalSetting.driver_pay_in_pence) {
                  expenseApprovalSetting.driver_pay_in_pence = 0;
                }
                let appraisalExpenseImage;

                if(i.uploadcare_image_url)
                {
                  if(i.uploadcare_image_url.includes("https://")){
                    appraisalExpenseImage = <img
                            src={i.uploadcare_image_url
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/images/placeholders/appraisal-placeholder.svg"
                            }}
                          />;
                  }else{
                    appraisalExpenseImage = <img
                            src={
                              "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/images/placeholders/appraisal-placeholder.svg"
                            }}
                          />;
                  }
                }
                else
                {
                  appraisalExpenseImage = <img
                          src={
                            "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/placeholders/appraisal-placeholder.svg"
                          }}
                        />;
                }
                Expenses.push(
                  <div className={(this.state.customerAllJobsPage && isCheckedOkForCustomer != 1) ? "row job-expenses-row toggle-hide" : "row job-expenses-row"}
                       key={"jobs-table-row-"+jobId+"-expense-"+expenseNum}
                       data-expense-name={i.photo_name} data-expense-index={expense_jobID}>
                    <input type="hidden" value={i.description} name="description" />
					          <input type="hidden" value={i.uploadcare_image_url} name="uploadcare_image_url" />
                    <div className="col-md-4 expense-image-container">
                      <a href=""
                         className="pop"
                         id={"jobs-table-row-"+jobId+"-expense-image-"+expenseNum}>
                          {appraisalExpenseImage}
                      </a>
                      <div>{i.description}</div>
                    </div>
                    <div className="col-md-3 input-group expense-cost-container">
                      <div className="input-group-prepend">
                        <span className="input-group-text">&pound;</span>
                      </div>
                      <input name="expense_cost_in_pence" className="form-control"
                              disabled={this.state.customerAllJobsPage ? true : false}
                             defaultValue={expenseDefaultValue} />
                    </div>
                    <div className={(this.state.customerAllJobsPage) ? "col-md-5 jobs-table-expenses-column toggle-hide" : "col-md-5 jobs-table-expenses-column"}>
                      <div className="row expense-approved-and-reason-container">
                        <div className="col-md-7"><b className="expense-approval-msg">{expensemsg}</b></div>
                        <div className="col-md-5">
                          <b>
                            <label className="checkbox-inline for-customer-dashboard">
                              <input type="checkbox" id={"ok_to_go_under_customer_login_"+expense_jobID} name="ok_to_go_under_customer_login" defaultValue="true"
                               defaultChecked={(isCheckedOkForCustomer == 1) ? true : false}
                                /> Ok to go under customer section ?
                            </label>
                          </b>
                        </div>
                        <div className="col-md-4">
                          <p>
                            Approved?
                          </p>
                          <div
                            className={"btn-group btn-group-toggle expense-form-radio-container "+expenseApproval}
                            data-toggle="buttons">
                            <label
                              className={
                                "btn btn-secondary expense-approved "+expenseApproved
                              }
                            >
                              <input
                                className="form-control form-control-lg"
                                name="expense_approved"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={
                                "btn btn-secondary expense-not-approved "+
                                expenseNotApproved
                              }
                            >
                              <input
                                className="form-control form-control-lg"
                                name="expense_approved"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div>
                        <div className="col-md-8">
                          <p>
                            Reason
                          </p>
                          <textarea
                            name="expense_reason"
                            className="form-control form-control-lg"
                            defaultValue={expenseReason}>
                          </textarea>
                        </div>

                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <p>
                            Client Charge 
                          </p>
                          <div className="input-group">
                            <div
                              className="input-group-prepend input-group-prepend-alt"
                            >
                              <div
                                className="input-group-text input-group-text-alt"
                              >&pound;</div>
                            </div>
                            <input
                              className="form-control form-control-lg text-left"
                              name="expense_client_charge"
                              readOnly={(self.state.data && self.state.data.fuel_included_in_job_price) ?
                                  'readOnly'
                                  :
                                 false
                              }
                              type="text"
                              defaultValue={
                                (expenseApprovalSetting.client_charge_in_pence/100
                                ).toFixed(2)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <p>
                            Driver Pay
                          </p>
                          <div className="input-group">
                            <div
                              className="input-group-prepend input-group-prepend-alt"
                            >
                              <div
                                className="input-group-text input-group-text-alt"
                              >&pound;</div>
                            </div>
                            <input
                              className="form-control form-control-lg text-left"
                              name="expense_driver_pay"
                              type="text"
                              defaultValue={
                                (expenseApprovalSetting.driver_pay_in_pence/100
                                ).toFixed(2)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <p>
                            Expense Type
                          </p>
                          <div className="row expense-type-options">
                            <div className="col-md-7">
                              <select
                                name="expense_type"
                                className="form-control form-control-lg"
                                defaultValue={expenseType}
                              >
                                <option value="4001">Fuel Oil Adblue</option>
                                <option value="4000">Vehicle Movements</option>
                                <option value="4002">Toll Road</option>
                                <option value="4003">Waitingtime</option>
                                <option value="4004">Storage</option>
                                <option value="4005">Breakdown</option>
                                <option value="4006">Travel</option>
                                <option value="4007">Car Wash</option>
                                <option value="4008">Parts</option>
                                <option value="4009">Transport Services</option>
                                <option value="7402">Hotel</option>
                                <option value="4014">Electric Charge Cost</option>
                                <option value="4015">Electric Charging Time</option>
                                <option value="4021">Truck Fuel</option>
                                <option value="4022">Truck Travel</option>
                                <option value="4023">Air</option>
                                <option value="4024">Food</option>
                                <option value="4025">Water</option>
                                <option value="4026">Coolant</option>
                                <option value="4027">Parking</option>
                              </select>
                            </div>
                            <div className="col-md-5">
                              <select
                                name="expense_vat_code"
                                className="form-control form-control-lg"
                                defaultValue={expenseVatCode}
                              >
                                <option value="t1">VAT</option>
                                <option value="t0">No VAT</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="expense-save-settings-button-container">
                        <p>
                          <button
                            className="btn btn-lg btn-dark save-settings-for-expense"
                            onClick={() => self.saveExpenseSettings(i.photo_name)}
                            disabled={this.state.isSavingExpenseSettings[i.photo_name] === true}
                          >
                            <i className="fa fa-save"></i>&nbsp;
                            {this.state.isSavingExpenseSettings[i.photo_name] === true
                              ? "Saving..."
                              : "Save settings for this expense"}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                )
            });
        }else{
            
            expense = (i.photo_name);
            if(i.photo_name == null || i.photo_name == ""){
                expense = jobId+'_photo_name_'+index;
            }
            expenseApprovalSettings = self.state.expense_approval_data;
            
            if (expense in expenseApprovalSettings) {
              expenseApprovalSetting = expenseApprovalSettings[expense];
              isCheckedOkForCustomer = expenseApprovalSetting.is_checked_togo_under_customer;
              expenseApproved = '';
              expenseNotApproved = '';
              if (expenseApprovalSetting.approved === 1) {
                expenseApproved = 'active';
                expensemsg = 'This expense has been approved.';
                expenseNotApproved = '';
                expenseApproval = 'disabled';
                expenseReason = expenseApprovalSetting.reason_for_approving;
              }
              else {
                expenseApproved = '';
                expenseNotApproved = 'active';
                expensemsg = 'This expense has been not approved.';
                expenseApproval = 'disabled';
                expenseReason = expenseApprovalSetting.reason_for_not_approving;
              }

              expenseDefaultValue = (
                expenseApprovalSetting.cost_in_pence/100
              ).toFixed(2);
              expenseType = expenseApprovalSetting.type;
              expenseVatCode = expenseApprovalSetting.vat_code;
              expenseCustomerVatCode = expenseApprovalSetting.customer_vat_code;

            }
            else {
              expenseDefaultValue = (i.cost_in_pence/100).toFixed(2);
              expenseApproved = '';
              expenseNotApproved = '';
              expenseReason = '';
              expenseType = '';
              expenseApproval = '';
              expenseVatCode = '';
              expenseCustomerVatCode = '';
              expensemsg = '';
              expenseApprovalSetting.driver_pay_in_pence = 0;
              expenseApprovalSetting.client_charge_in_pence = 0;
            }
            expenseNum++;

            if (!expenseApprovalSetting.client_charge_in_pence) {
              expenseApprovalSetting.client_charge_in_pence = 0;
            }

            if (!expenseApprovalSetting.driver_pay_in_pence) {
              expenseApprovalSetting.driver_pay_in_pence = 0;
            }
            let appraisalExpenseImage;

            if(i.uploadcare_image_url)
            {
              if(i.uploadcare_image_url.includes("https://")){
                appraisalExpenseImage = <img
                        src={i.uploadcare_image_url
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/images/placeholders/appraisal-placeholder.svg"
                        }}
                      />;
              }else{
                appraisalExpenseImage = <img
                        src={
                          "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/images/placeholders/appraisal-placeholder.svg"
                        }}
                      />;
              }
            }
            else
            {
              appraisalExpenseImage = <img
                      src={
                        "/storage/images/jobs/"+jobId+"/expenses_images/"+i.photo_name
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/images/placeholders/appraisal-placeholder.svg"
                      }}
                    />;
            }
            Expenses.push(
              <div className={(this.state.customerAllJobsPage && isCheckedOkForCustomer != 1) ? "row job-expenses-row toggle-hide" : "row job-expenses-row"}
                   key={"jobs-table-row-"+jobId+"-expense-"+expenseNum}
                   data-expense-name={i.photo_name} data-expense-index={expense_jobID}>
                <input type="hidden" value={i.description} name="description" />
                <input type="hidden" value={i.uploadcare_image_url} name="uploadcare_image_url" />
                <div className="col-md-4 expense-image-container">
                  <a href=""
                     className="pop"
                     id={"jobs-table-row-"+jobId+"-expense-image-"+expenseNum}>
                      {appraisalExpenseImage}
                  </a>
                  <div>{i.description}</div>
                </div>
                <div className="col-md-3 input-group expense-cost-container">
                  <div className="input-group-prepend">
                    <span className="input-group-text">&pound;</span>
                  </div>
                  <input name="expense_cost_in_pence" className="form-control"
                  disabled={this.state.customerAllJobsPage ? true : false}
                         defaultValue={expenseDefaultValue} />
                </div>
                <div className={(this.state.customerAllJobsPage) ? "col-md-5 jobs-table-expenses-column toggle-hide" : "col-md-5 jobs-table-expenses-column"}>
                  <div className="row expense-approved-and-reason-container">
                    <div className="col-md-7"><b className="expense-approval-msg">{expensemsg}</b></div>
                    <div className="col-md-5">
                          <b>
                            <label className="checkbox-inline for-customer-dashboard">
                              <input type="checkbox" id={"ok_to_go_under_customer_login_"+expense_jobID} name="ok_to_go_under_customer_login" defaultValue="true"
                                defaultChecked={(isCheckedOkForCustomer == 1) ? true : false}
                                /> Ok to go under customer section ?
                            </label>
                          </b>
                        </div>
                    <div className="col-md-4">
                      <p>
                        Approved?
                      </p>
                      <div
                        className={"btn-group btn-group-toggle expense-form-radio-container "+expenseApproval}
                        data-toggle="buttons">
                        <label
                          className={
                            "btn btn-secondary expense-approved "+expenseApproved
                          }
                        >
                          <input
                            className="form-control form-control-lg"
                            name="expense_approved"
                            type="radio"
                            value="1"
                            required
                          /> YES
                        </label>
                        <label
                          className={
                            "btn btn-secondary expense-not-approved "+
                            expenseNotApproved
                          }
                        >
                          <input
                            className="form-control form-control-lg"
                            name="expense_approved"
                            type="radio"
                            value="0"
                            required
                          /> NO
                        </label>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        Reason
                      </p>
                      <textarea
                        name="expense_reason"
                        className="form-control form-control-lg"
                        defaultValue={expenseReason}>
                      </textarea>
                    </div>

                  </div>
                  <div className="row">
                  <div className="col-md-6">
                      <p>
                        Client Charge
                      </p>
                      <div className="input-group">
                        <div
                          className="input-group-prepend input-group-prepend-alt"
                        >
                          <div
                            className="input-group-text input-group-text-alt"
                          >&pound;</div>
                        </div>
                        <input
                            className="form-control form-control-lg text-left"
                            name="expense_client_charge"
                            readOnly={(self.state.data && self.state.data.fuel_included_in_job_price) ?
                                'readOnly'
                                :
                               false
                            }
                            type="text"
                            defaultValue={
                              (expenseApprovalSetting.client_charge_in_pence/100
                              ).toFixed(2)
                            }
                          />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <p>
                        Driver Pay
                      </p>
                      <div className="input-group">
                        <div
                          className="input-group-prepend input-group-prepend-alt"
                        >
                          <div
                            className="input-group-text input-group-text-alt"
                          >&pound;</div>
                        </div>
                        <input
                          className="form-control form-control-lg text-left"
                          name="expense_driver_pay"
                          type="text"
                          defaultValue={
                            (expenseApprovalSetting.driver_pay_in_pence/100
                            ).toFixed(2)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p>
                        Expense Type
                      </p>
                      <div className="row expense-type-options">
                        <div className="col-md-7">
                          <select
                            name="expense_type"
                            className="form-control form-control-lg"
                            defaultValue={expenseType}
                          >
                            <option value="4001">Fuel Oil Adblue</option>
                            <option value="4000">Vehicle Movements</option>
                            <option value="4002">Toll Road</option>
                            <option value="4003">Waitingtime</option>
                            <option value="4004">Storage</option>
                            <option value="4005">Breakdown</option>
                            <option value="4006">Travel</option>
                            <option value="4007">Car Wash</option>
                            <option value="4008">Parts</option>
                            <option value="4009">Transport Services</option>
                            <option value="7402">Hotel</option>
                            <option value="4014">Electric Charge Cost</option>
                            <option value="4015">Electric Charging Time</option>
                            <option value="4021">Truck Fuel</option>
                            <option value="4022">Truck Travel</option>
                            <option value="4023">Air</option>
                            <option value="4024">Food</option>
                            <option value="4025">Water</option>
                            <option value="4026">Coolant</option>
                            <option value="4027">Parking</option>
                          </select>
                        </div>
                        <div className="col-md-5">
                          <select
                            name="expense_vat_code"
                            className="form-control form-control-lg"
                            defaultValue={expenseVatCode}
                          >
                            <option value="t1">VAT</option>
                            <option value="t0">No VAT</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="expense-save-settings-button-container">
                    <p>
                      <button
                          className="btn btn-lg btn-dark save-settings-for-expense"
                          onClick={() => self.saveExpenseSettings(i.photo_name)}
                          disabled={this.state.isSavingExpenseSettings[i.photo_name] === true}
                        >
                          <i className="fa fa-save"></i>&nbsp;
                          {this.state.isSavingExpenseSettings[i.photo_name] === true
                            ? "Saving..."
                            : "Save settings for this expense"}
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            )
        }
        
      });
      expensesInfoBlock = (
        <div>
          <div className="job-expenses-row"></div>
          {Expenses}
        </div>
      );
    }
    return expensesInfoBlock;
  }
  render() {
    let  isCustomerAgreedForCheckList = (this.state.data.has_admin_agreed_for_checklist) ? this.state.data.has_admin_agreed_for_checklist : false;
    
    return (
      <div>
        {this.state.isLoadingExpensesInfo ?
          <div className="loading-box">
              <span className="add-loading-text">
                <i className="fa fa-spinner fa-pulse"></i>
              </span>
          </div>
          :
          <div>
            <div className="row">
              <div className="col-md-12">
                {!this.state.customerAllJobsPage ? 
                  (this.state.data.fuel_included_in_job_price === 1) ?
                  <strong>Fuel Included in Job Price</strong>
                  :
                  <strong>Fuel Not Included in Job Price</strong>
                : ""}
                <div>
                  <div className={!this.state.customerAllJobsPage ? "row padding-top-btm" : "row padding-top-btm toggle-hide"}>
                    <div className="col-md-9">
                      <div className="row col-md-12 mrgn-btm">
                        <div className="col-md-3">
                          <strong>Expense Pre Approval</strong>
                        </div>
                        <div className="col-md-6">
                            <button className="btn btn-lg btn-dark save-pre-approve-expense-settings same-width-btn"
                            onClick={(e) => {
                              this.savePreApprovedExpenseOptions(e)
                            }}>
                              <i className="fa fa-save"></i>&nbsp; Save Pre Approval
                            </button>
                          </div>
                      </div>
                      {
                        this.state.preApprovalExp.map((eItem,index)=>{
                          return(
                          <div className="row col-md-12 mrgn-btm" key={index}>
                          <div className="col-md-3">
                              <select name="pre_approved_expense_type" className="form-control form-control-lg"
                              value={eItem.pre_approved_expense_type}
                              onChange={(e) => {
                                this.handlePreApprovedExpenseType(e,index)
                              }}>
                                <option value="4001">Fuel</option>
                                <option value="4006">Bus</option>
                                <option value="4000">Taxi</option>
                                <option value="4009">Train</option>
                                <option value="7402">Hotel</option>
                              </select> 
                          </div>
                          <div className="col-md-3">
                              <select name="pre_approved_percentage" className="form-control form-control-lg" 
                              value={eItem.pre_approved_expense_percentage}
                              onChange={(e) => {
                                this.handlePreApprovedPercentage(e,index)
                              }}>
                                <option value="0">0</option>
                                <option value="full">Full</option>
                                <option value="half">Half</option>
                              </select>
                          </div>
                          <div className="col-md-3">
                            <textarea className="form-control form-control-lg"
                                        name="pre_approved_expense_reason"
                                        id="pre_approved_expense_reason" placeholder="Enter Reason"
                                        value={eItem.pre_approved_expense_reason}
                                        onChange={(e) => {
                                        this.handlePreApprovedExpenseReason(e,index)
                                        }}
                            >
                            </textarea>
                          </div>
                          {(index == 0) ?
                            <div className="col-md-3"> 
                              <button type="button" className="btn btn-primary" onClick={(e)=>this.handleAddMoreBtnClick(e)}> + Add more</button>
                            </div> : ""
                          }
                          {(index != 0) ?
                            <div className="remove-current-list-item" title="Remove item">
                              <a className="alert alert-danger" 
                              onClick={(e)=>this.handleRemoveSelectedPItem(e,index)}>
                                <i className="fa">&#xf00d;</i>
                              </a>
                            </div>
                          : ''}
                          
                          <br/>
                          </div>
                          )
                        })
                      }
                    </div>
                    <div className="col-md-3">
                      
                    </div>
                  </div>
                  {this.renderExpensesInfoBlock()}
                </div>
              </div>
            </div>
            
            <button className={(this.state.customerAllJobsPage) ? "btn btn-lg toggle-hide" : "btn btn-lg"}
                    onClick={(e) => {
                      this.setState({
                        showAddExpenseForm: !this.state.showAddExpenseForm
                      });
                    }
                    }
            >
              <i className="fa fa-plus"></i> Add New Expense
            </button>
            {(this.state.showAddExpenseForm) ?
              <div
                className="row"
                id={
                  'add-expense-to-job-' +
                  this.state.data.id
                }
              >
                <div className="col-md-12">
                  <h4>Add Expense</h4>
                  <p>
                    Expense Type:<br/>
                    <input
                      type="text"
                      name="add_expense_expense_type"
                      className="form-control form-control-lg"
                      id={
                        "add-expense-expense-type-" +
                        this.state.data.id
                      }
                    />
                  </p>
                  <p>
                    Cost:<br/>
                    <input
                      type="text"
                      name="add_expense_expense_cost"
                      className="form-control form-control-lg"
                      id={
                        "add-expense-expense-cost-" +
                        this.state.data.id
                      }
                    />
                  </p>
                  <div className="form-group image-upload-container">
                    <label htmlFor="portal_account_photo">
                      Expense Image
                    </label>
                    <input
                      type='file'
                      onChange={
                        this.handleAddExpenseFileConvert
                      }
                      className="form-control form-control-lg"
                      id={
                        "add-expense-expense-image-input-" +
                        this.state.data.id
                      }
                    />
                    <input
                      type="hidden"
                      name="image-base-64"
                      id={
                        "add-expense-expense-image-b64-" +
                        this.state.data.id
                      }
                    />
                  </div>
                  <p>
                    <img
                      id={
                        "add-expense-expense-image-" +
                        this.state.data.id
                      }
                    />
                  </p>
                  <p>
                    <button
                      className="btn btn-lg btn-success"
                      onClick={(e) => {
                        this.addNewExpenseToJob(e)
                      }}
                      disabled={this.state.isAddingExpense}
                    >
                      <i className="fa fa-plus"></i>&nbsp;
                     {this.state.isAddingExpense ? "Adding..." : " Add New Expense"}
                    </button>
                  </p>
                </div>
              </div>
              :
              ''
            }
            <div className={(this.state.customerAllJobsPage) ? "text-right toggle-hide" : "text-right" }>
            <a href="#"
                        onClick={(e) => {
                          this.downloadExpensesImagesForJob(
                            e,
                            this.state.data.id
                          )
                        }}
                        className="btn btn-lg btn-success appraisal-download-button same-width-btn downloadExpenseImage">
                        <i className="fa fa-download"></i> Download Expenses Images as .zip
                      </a>
              {( (this.state.data.checked === 1) &&
                (this.state.data.checked_by) &&
                (this.state.data.checked_by.first_name)) ?
                <p>
                  <button className="btn btn-lg btn-success">
                    Job Checked (by {this.state.data.checked_by.first_name
                  }&nbsp;{this.state.data.checked_by.last_name} on {
                    this.state.data.checked_at
                  })
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-lg btn-dark job-row-highlighter-option-green"
                    title={"Toggle Mark Job as: JOB IS READY TO SEND" +
                    "TO DRIVER OR OUTSOURCED"}
                    onClick={(e) => this.toggleMarkJobAsChecked(e,0)}
                    disabled={(this.state.isMarkJobAsCheckedLoading) ? true:false}
                  >
                    <i className="fa fa-undo"></i>&nbsp;
                    Unmark Job As Checked
                  </button>
                </p>
                :
                <p>Job Not Checked<br/>
                  <button
                    className="btn btn-lg btn-dark job-row-highlighter-option-green same-width-btn"
                    title={"Toggle Mark Job as: JOB IS READY TO SEND" +
                    "TO DRIVER OR OUTSOURCED"}
                    onClick={(e) => this.toggleMarkJobAsChecked(e,1)}
                    disabled={(this.state.isMarkJobAsCheckedLoading) ? true:false}
                  >
                    Mark Job As Checked
                  </button>
                </p>

              }
              {(this.state.data.ready_for_wages === 1) ?
                  <button className="btn btn-lg btn-dark same-width-btn"
                  disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? true:false}
                  onClick={(e)=>this.handleNotApproveJobToGoOnWagesSheet(e)}>
                    UnApprove job to go on invoices sheet ?
                  </button>
                  : <button className="btn btn-lg btn-primary same-width-btn"
                  disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? true:false}
                  onClick={(e)=>this.handleApproveJobToGoOnWagesSheet(e)}>
                    Approve job to go on invoices sheet ?
                  </button>
                  }
            </div>
            {(this.state.data.ready_for_invoice === 1) ?
            <div className={ (this.state.customerAllJobsPage) ? "row  toggle-hide" : "row"}>
              <div className="col-md-9">
                    <div className="row pdng-top-50"></div>
                    <div className="row">
                        <div className="col-md-2">
                        <div className="form-group">
                          
                          <div
                            className="btn-group btn-group-toggle"
                            id="yes-driver-fuel-expense-included-in-job-price-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.data &&
                              this.state.data.fuel_included_in_job_price === 1
                                ?
                                ' active '
                                : ''
                            )
                                  }
                                  id="yes-driver-fuel-expense-included-in-job-price">
                              <input className="form-control form-control-lg"
                                    name="driver_fuel_expense_included_in_job_price"
                                    type="radio" value="1"/> YES
                            </label>
                            <label className={"btn btn-secondary" + (
                              this.state.data &&
                              this.state.data.fuel_included_in_job_price === 0
                                ?
                                ' active '
                                : ''
                            )
                                  }
                                  id="no-driver-fuel-expense-included-in-job-price">
                              <input className="form-control form-control-lg"
                                    name="driver_fuel_expense_included_in_job_price"
                                    type="radio" value="0"/> NO
                            </label>
                          </div>
                        </div>
                      </div>
                        <div className="col-md-3">
                          <label>
                            Fuel Included in Job Price?
                          </label>
                        </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                            <div className="form-group">
                              
                              <div
                                className="btn-group btn-group-toggle"
                                id="fleet-paperwork-form-radio-container"
                                data-toggle="buttons">
                                <label className={"btn btn-secondary" + (
                                  this.state.data &&
                                  (this.state.data.fleet_paperwork_required === 1)
                                    ?
                                    ' active '
                                    : ''
                                )
                                }
                                  id="yes-fleet-paperwork">
                                  <input
                                    className="form-control form-control-lg"
                                    name="vehicle_fleet_paperwork_required"
                                    type="radio"
                                    value="1"
                                    required
                                  /> YES
                                </label>
                                <label className={"btn btn-secondary" + (
                                  this.state.data &&
                                  (this.state.data.fleet_paperwork_required === 0)
                                    ?
                                    ' active '
                                    : ''
                                )
                                }
                                      id="no-fleet-paperwork">
                                  <input className="form-control form-control-lg"
                                        name="vehicle_fleet_paperwork_required"
                                        type="radio" value="0" required/> NO
                                </label>
                              </div>
                              </div>
                          </div>
                      <div className="col-md-3">
                          <label>
                            Fleet Paperwork required?
                          </label>
                      </div>
                    </div>               
                    <div className="row">
                      <div className="col-md-2">
                      <div className="form-group">
                                
                                <div
                                  className="btn-group btn-group-toggle"
                                  id="jet-wash-form-radio-container"
                                  data-toggle="buttons">
                                  <label className={"btn btn-secondary" + (
                                    this.state.data &&
                                    this.state.data.jet_wash_required === 1
                                      ?
                                      ' active '
                                      : ''
                                  )
                                  }
                                        id="yes-jet-wash">
                                    <input
                                      className="form-control form-control-lg"
                                      name="vehicle_jet_wash_required"
                                      type="radio"
                                      value="1"
                                      required
                                    /> YES
                                  </label>
                                  <label className={"btn btn-secondary" + (
                                    this.state.data &&
                                    this.state.data.jet_wash_required === 0
                                      ?
                                      ' active '
                                      : ''
                                  )
                                  }
                                        id="no-jet-wash">
                                    <input
                                      className="form-control form-control-lg"
                                      name="vehicle_jet_wash_required"
                                      type="radio"
                                      value="0"
                                      required
                                    /> NO
                                  </label>
                                </div>
                              </div>
                      </div>
                      <div className="col-md-3">
                          <label>
                            Jet Wash required?
                          </label>
                      </div>
                    </div>  
              </div>

              <div className="col-md-3">
              <div className="text-right">
                <br/>
                <span>
                  <strong>Job ready to be invoiced</strong>
                </span>
                </div>
                <div className="text-left">
                  <div className="checkbox redy-for-invoice-checklist-chkbox">
                      <label className="design-customer-line-height"> Has all PPW been received verified and send off to customer ?<br/>
                       Have all external portals been completed ?<br/>
                      Has fuel account been updated ?<br/>
                       Have the pods been sent off to the customer if required ?<br/>
                       Did the driver cross the Dartford Bridge - If so has the crossing been paid for ? 
                        <input type="checkbox" name="invoice_checklist_have_the_pods_been_sent_off text-left"
                              id="invoice_checklist_have_the_pods_been_sent_off"
                              defaultValue="true"
                              defaultChecked={isCustomerAgreedForCheckList}
                              disabled={true} />

                        <span className="cr">
                          <i className="cr-icon fa fa-check"></i> 
                        </span>
                      </label>
                  </div>
                  <p className="text-right">
                  <button
                    className="btn btn-lg btn-warning same-width-btn rdc-mrgn-left"
                    disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? true:false}
                    onClick={() => {
                      this.setJobAsNotReadyToBeInvoiced(
                        this.state.data.id
                      )
                    }}>
                    Set Job as not ready to be invoiced
                  </button>
                </p> 
              </div>
              </div>
              </div>
              :
              <div>
                <div className={ (this.state.customerAllJobsPage) ? "row  toggle-hide" : "row"}>
                  <div className="col-md-9">
                      <div className="row pdng-top-50"></div>
                      <div className="row">
                          <div className="col-md-2">
                          <div className="form-group">
                            
                            <div
                              className="btn-group btn-group-toggle"
                              id="yes-driver-fuel-expense-included-in-job-price-form-radio-container"
                              data-toggle="buttons">
                              <label className={"btn btn-secondary" + (
                                this.state.data &&
                                this.state.data.fuel_included_in_job_price === 1
                                  ?
                                  ' active '
                                  : ''
                              )
                                    }
                                    id="yes-driver-fuel-expense-included-in-job-price">
                                <input className="form-control form-control-lg"
                                      name="driver_fuel_expense_included_in_job_price"
                                      type="radio" value="1"/> YES
                              </label>
                              <label className={"btn btn-secondary" + (
                                this.state.data &&
                                this.state.data.fuel_included_in_job_price === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                                    }
                                    id="no-driver-fuel-expense-included-in-job-price">
                                <input className="form-control form-control-lg"
                                      name="driver_fuel_expense_included_in_job_price"
                                      type="radio" value="0"/> NO
                              </label>
                            </div>
                          </div>
                        </div>
                          <div className="col-md-3">
                            <label>
                              Fuel Included in Job Price?
                            </label>
                          </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2">
                              <div className="form-group">
                                
                                <div
                                  className="btn-group btn-group-toggle"
                                  id="fleet-paperwork-form-radio-container"
                                  data-toggle="buttons">
                                  <label className={"btn btn-secondary" + (
                                    this.state.data &&
                                    (this.state.data.fleet_paperwork_required === 1)
                                      ?
                                      ' active '
                                      : ''
                                  )
                                  }
                                    id="yes-fleet-paperwork">
                                    <input
                                      className="form-control form-control-lg"
                                      name="vehicle_fleet_paperwork_required"
                                      type="radio"
                                      value="1"
                                      required
                                    /> YES
                                  </label>
                                  <label className={"btn btn-secondary" + (
                                    this.state.data &&
                                    (this.state.data.fleet_paperwork_required === 0)
                                      ?
                                      ' active '
                                      : ''
                                  )
                                  }
                                        id="no-fleet-paperwork">
                                    <input className="form-control form-control-lg"
                                          name="vehicle_fleet_paperwork_required"
                                          type="radio" value="0" required/> NO
                                  </label>
                                </div>
                                </div>
                            </div>
                        <div className="col-md-3">
                            <label>
                              Fleet Paperwork required?
                            </label>
                        </div>
                      </div>               
                      <div className="row">
                      <div className="col-md-2">
                      <div className="form-group">
                                
                                <div
                                  className="btn-group btn-group-toggle"
                                  id="jet-wash-form-radio-container"
                                  data-toggle="buttons">
                                  <label className={"btn btn-secondary" + (
                                    this.state.data &&
                                    this.state.data.jet_wash_required === 1
                                      ?
                                      ' active '
                                      : ''
                                  )
                                  }
                                        id="yes-jet-wash">
                                    <input
                                      className="form-control form-control-lg"
                                      name="vehicle_jet_wash_required"
                                      type="radio"
                                      value="1"
                                      required
                                    /> YES
                                  </label>
                                  <label className={"btn btn-secondary" + (
                                    this.state.data &&
                                    this.state.data.jet_wash_required === 0
                                      ?
                                      ' active '
                                      : ''
                                  )
                                  }
                                        id="no-jet-wash">
                                    <input
                                      className="form-control form-control-lg"
                                      name="vehicle_jet_wash_required"
                                      type="radio"
                                      value="0"
                                      required
                                    /> NO
                                  </label>
                                </div>
                              </div>
                      </div>
                      <div className="col-md-3">
                          <label>
                            Jet Wash required?
                          </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                <div className="text-right">
                  <br/>
                  <span>
                    <strong>Job not ready to be invoiced</strong>
                  </span>
                  </div>
                  <div className="text-left">
                  <div>
                    <div className="checkbox redy-for-invoice-checklist-chkbox">
                        <label className="design-customer-line-height"> Has all PPW been received verified and sent off to customer ?<br/>
                        Have all external portals been completed ?<br/>
                        Has fuel account been updated ?<br/>
                        Have the pods been sent off to the customer if required ?<br/>
                        Did the driver cross the Dartford Bridge - If so has the crossing been paid for ? 
                          <input type="checkbox" name="invoice_checklist_have_the_pods_been_sent_off text-left"
                                id="invoice_checklist_have_the_pods_been_sent_off"
                                defaultValue="true"
                                defaultChecked={isCustomerAgreedForCheckList}
                                onChange={this.handleChangeChk}  />

                          <span className="cr">
                            <i className="cr-icon fa fa-check"></i> 
                          </span>
                        </label>
                    </div>
                  </div>
                  <p className="text-right">
                    <button
                      className="btn btn-lg btn-primary same-width-btn rdc-mrgn-left"
                      id="setJobReadyToBeInvoice"
                      disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? true:false}
                      onClick={() => {
                        this.setJobAsReadyToBeInvoiced(
                          this.state.data.id
                        )
                      }}>
                      Set Job as ready to be invoiced
                    </button>
                  </p>
                </div>
                </div>
                </div>
                </div>
            }
            </div>

        }
      </div>
    );
  }
}